import { useSuspenseQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";

import { DOCUMENT_TITLES, documentHead } from "#/lib/documentTitle";
import { publicProfileQueryOptions } from "#/lib/queries";

import { AchievementsCard, AchievementsCardSkeleton } from "./-profile.achievements";
import { ProfileActivityCard, ProfileActivityCardSkeleton } from "./-profile.activityGraph";
import {
  ProfilePageScaffold,
  ProfilePageTitle,
  ProfilePageTitleSkeleton,
} from "./-profile.scaffold";
import { StatsCard, StatsCardSkeleton } from "./-profile.statsBody";

export const Route = createFileRoute("/profile_/$name")({
  head: () => documentHead(DOCUMENT_TITLES.profile),
  loader: async ({ context, params: { name } }) => {
    await context.queryClient.ensureQueryData(publicProfileQueryOptions(name));
    return { name };
  },
  pendingComponent: PublicProfilePageLoading,
  component: PublicProfilePage,
});

function PublicProfilePageLoading() {
  return (
    <ProfilePageScaffold eyebrow="Public profile" title={<ProfilePageTitleSkeleton />}>
      <ProfileActivityCardSkeleton />
      <AchievementsCardSkeleton />
      <StatsCardSkeleton />
    </ProfilePageScaffold>
  );
}

function PublicProfilePage() {
  const { name } = Route.useLoaderData();
  const {
    data: { profile, activity, achievements, earnedAchievementCount },
  } = useSuspenseQuery(publicProfileQueryOptions(name));

  return (
    <ProfilePageScaffold
      eyebrow="Public profile"
      title={
        <ProfilePageTitle
          displayName={profile.displayName}
          goldMedals={profile.goldMedals}
          silverMedals={profile.silverMedals}
          bronzeMedals={profile.bronzeMedals}
          challengeStars={profile.challengeStars}
        />
      }
    >
      <ProfileActivityCard activity={activity} />
      <AchievementsCard
        achievements={achievements}
        displayName={profile.displayName}
        earnedCount={earnedAchievementCount}
      />
      <StatsCard profile={profile} />
    </ProfilePageScaffold>
  );
}
